import React, { useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import QuotaModal from './QuotaModal';
import { isKycSubscriptionExpired } from './utils';
import { TokenContext } from '../../App';

/**
 * 登录后订阅到期提示框
 * 登录进入系统时检查公司订阅（kycSettings.nextResetDate），已到期则弹框提示
 */
const SubscriptionExpiredModal = () => {
  const [open, setOpen] = useState(false);
  const [encodedAccessToken] = useContext(TokenContext);

  useEffect(() => {
    let decodedToken;
    try {
      decodedToken = jwtDecode(encodedAccessToken);
    } catch (e) {
      return;
    }

    // 仅对开通了 KYC 订阅的公司用户检查，superAdmin 除外
    if (decodedToken?.role === 'superAdmin' || !decodedToken?.subscriptions?.kyc_aml) {
      return;
    }

    isKycSubscriptionExpired().then(expired => {
      if (expired) {
        setOpen(true);
      }
    });
  }, []);

  return (
    <QuotaModal
      isOpen={open}
      onClose={() => setOpen(false)}
      title='Subscription Expired'
      contentLines={['Your subscription has expired.', 'Access to the system has been restricted.']}
      warningText='Please contact the iCOMPASS Support Team for further assistance.'
    />
  );
};

export default SubscriptionExpiredModal;
